import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectFetched, {
	type SubjectFetchedAction,
	type SubjectPayload,
} from '@Application/Subjects/Actions/subjectFetched';
import subjectFetchFailed, {
	type SubjectFetchFailedAction,
} from '@Application/Subjects/Actions/subjectFetchFailed';
import type FetchSubject from '@Application/Subjects/Queries/FetchSubject';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectFetchedAction | SubjectFetchFailedAction;

export default (query: FetchSubject) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectPayload>(
				`${parameters.api.host}/api/facilities/${query.facilityId}/subjects/${query.subjectId}`,
			);

			const action = subjectFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
